import * as queryString from "query-string-object";
import baseRequest from "./baseReuqest";

const toKebabCase = (value) => value.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

export function getGreenApiData(page, per_page, order, order_by) {
    let url = '/api/whatsapp/green_api';
    const q = queryString.stringify({page, per_page, order, order_by});
    if (q) {
        url += `?${q}`;
    }
    return baseRequest(url);
}

export function getWebhookHistory(page, per_page, order, order_by) {
    let url = '/api/instance/webhook-history';
    const q = queryString.stringify({page, per_page, order, order_by});
    if (q) {
        url += `?${q}`;
    }
    return baseRequest(url);
}

export function getAuthorizedInstances() {
    return baseRequest('/api/instance/authorized');
}

export function getInstancesByVendor(vendor, page, per_page, order, order_by) {
    let url = `/api/instance/${toKebabCase(vendor)}/all`;
    const q = queryString.stringify({page, per_page, order, order_by});
    if (q) {
        url += `?${q}`;
    }
    return baseRequest(url);
}

export function createInstance(vendor, payload) {
    return baseRequest(`/api/instance/${toKebabCase(vendor)}/create`, {
        method: 'POST',
        body: payload,
    });
}

export function updateAllInstancesStatus(vendor) {
    return baseRequest(`/api/instance/${toKebabCase(vendor)}/status/update-all`, {
        method: 'PUT',
    });
}

export function editInstance(instanceId, payload) {
    return baseRequest(`/api/instance/${instanceId}/edit`, {
        method: 'PUT',
        body: payload,
    });
}

export function deleteInstance(instanceId) {
    return baseRequest(`/api/instance/${instanceId}/delete`, {
        method: 'PUT',
    });
}

export function updateInstanceStatus(instanceId) {
    return baseRequest(`/api/instance/${instanceId}/status/update-one`, {
        method: 'PUT',
    });
}

export function rebootInstance(instanceId) {
    return baseRequest(`/api/instance/${instanceId}/reboot`, {
        method: 'PUT',
    });
}

export function logoutInstance(instanceId) {
    return baseRequest(`/api/instance/${instanceId}/logout`, {
        method: 'PUT',
    });
}
